export default "__VITE_ASSET__CEmhX5Qq__"